import { cloneDeep } from 'lodash';
import PromotersActions from '../actions/PromoterCRUDActions';
import { startBotCRUDActions } from '../actions/StartBotCrudActions';
import Actions from '../actions/actions';
import {
  setBusy,
  update,
  deleteLocalFirst,
  retrievedAll,
  setUnBusy,
  addEntity,
} from './common/commonReducers';
import { PromoterState } from '../interfaces/promoter';

const initialState: PromoterState = {
  entities: [],
  busy: false,
  catchAll: null,
};

function setCatchAll(state: PromoterState, action): PromoterState {
  const catchAll = action.entity[0] || {};

  return {
    ...state,
    busy: false,
    catchAll,
  };
}

function clearCatchAll(state: PromoterState) {
  const stateCopy = cloneDeep(state);

  return {
    ...stateCopy,
    catchAll: null,
  };
}

function addPromoter(state: PromoterState, action) {
  const entityIndex = state.entities.findIndex(e => e.id === action.entity.id);
  if (entityIndex > -1) return update(state, action);
  return addEntity(state, action);
}

function promoter(state = initialState, action) {
  switch (action.type) {
    case startBotCRUDActions.busyAction:
      return setBusy(state);
    case PromotersActions.busyAction:
      return setBusy(state);
    case PromotersActions.retrievedAllAction:
      return retrievedAll(state, action, true);
    case PromotersActions.retrievedAction:
      return addPromoter(state, action);
    case PromotersActions.updateAction: {
      return update(state, action);
    }
    case PromotersActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case PromotersActions.retrievedCatchAllAction:
      return setCatchAll(state, action);
    case PromotersActions.clearCatchAllAction:
      return clearCatchAll(state);
    case PromotersActions.unbusyAction:
      return setUnBusy(state);
    case startBotCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}

export default promoter;
